<template>

    <div class="col-12 pb-5">
        <div >
            <div v-if="errors">
                {{ errors }}
            </div>

                <div class="row">
                    <div class="col-12 text-center">
                        <h2>{{ round }} Voting</h2>
                        <p>{{ instructions }}</p>
                    </div>
                </div>

            <form>
                <div class="row">
                    <div class="col-12 d-flex align-items-center filter-wrap-orders-judge">
                        <div class="filter-wrap w-100 d-flex justify-content-around" v-if="filters.length > 0">
                            <a href="#" @click.prevent="filterData('a-z', -1)" class="btn btn-transparent judge-filter-letter" :class="(query_judge_grouping == -1) ? 'btn-active' : ''" data-attr="showall">Show All</a>
                            <a v-for="(filter, index) in filters" @click.prevent="filterData(filter, index)" href="#" class="btn btn-transparent judge-filter-letter" :class="(query_judge_grouping == index) ? 'btn-active' : ''" :data-attr="filter" >{{ filter }}</a>
                        </div>
                        <div class="form-search-wrap w-100 position-relative pl-2">
                            <div class="choices-filter-group double position-relative">
                                <input class="form-search-wrap" type="text" name="keyword" id="keyword" placeholder="Search by Program Title" v-model="query_keyword">
                            </div>
                            <div class="position-absolute clear-search-orders-table">
                                <a class="clear-button no-border cursor-pointer" v-on:click.stop="clearSearch()"><closeicon class="svg-18"></closeicon>Clear Search</a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <br/>

            <div class="judging-table entries-table-wrap">
                <p class="red" v-if="showTooManySelected">You are at the maximum values selected.</p>
                <table id="sortable-table" class="nice-table">
                    <thead>

                    <tr class="tableHeaderRow">
                        <th style="width: 145px;" class="th-entry pl-2 cursor-initial"></th>
                        <th class="th-program" v-on:click="setSort('program_title')">Program Title <i class="fa" :class="((sort_order != 'desc') && (sort == 'program_title')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                        <th class="th-network" v-on:click="setSort('cable_network')">Network <i class="fa" :class="((sort_order != 'desc') && (sort == 'cable_network')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                        <th class="th-issues">Issue Covered</th>
                        <th class="th-note-icon cursor-initial">Notes</th>
                        <th style="width: 130px;" class="th-select cursor-initial">Selection</th>
                    </tr>
                    </thead>
                    <tbody v-for="(order,i) in allorders" class="no-border-td">
                    <tr>
                        <td class="pl-2" @click="loadOrder(order.order_id)"><div><img class="table-image" :src="order.program_logo_preview"></div></td>
                        <td @click="loadOrder(order.order_id)"><div>{{ order.program_title }}</div></td>
                        <td @click="loadOrder(order.order_id)"><div>{{ order.cable_network }}</div></td>
                        <td @click="loadOrder(order.order_id)"><div>{{ order.issue_covered }}</div></td>
                        <td class="" @click="showNoteModal(order, i)">
                            <div class="text-center justify-content-center">
                                <fileicon v-if="order.judgements[0].notes" class="svg-24 svg-black w-hover"></fileicon>
                                <plusicon v-if="!order.judgements[0].notes" class="svg-24 svg-black w-hover"></plusicon>
                            </div>
                        </td>
                        <td class="checkboxes justify-content-center">
                            <div class="checkout-checkbox-wrapper pull-right table-checkbox w-100 justify-content-center">
                                <input v-model="order.judgements[0].selection" type="checkbox" :id="'order_ids_'+order.id" class="checkbox hide-me" name="order_ids[]" @click="saveSelection(order, $event)">
                                <label class="box-checking" :for="'order_ids_'+ order.id "></label>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div style="float:right;">
                <pagination :data="orders" @pagination-change-page="paginationCalculator" :limit="3">
                    <span slot="prev-nav">&lt; Previous</span>
                    <span slot="next-nav">Next &gt;</span>
                </pagination>
            </div>
            <div class="dataTables_info">Showing 1-{{to}} of {{ total }} submissions</div>
            <div class="dataTables_length admin-entry-table">
                <label>
                    <span>Show</span>
                    <select class="plain-select num-entries-select" v-model="num" @change="fetchOrders()">
                        <option value="10">10 Submissions</option>
                        <option value="20">20 Submissions</option>
                        <option value="50">50 Submissions</option>
                        <option value="100">100 Submissions</option>
                        <option value="all">All Submissions</option>
                    </select>
                    <span>per page</span>
                </label>
            </div>

            <modal v-if="noteModalTrigger">
                <div slot="header" class="d-flex justify-content-between full-width">
                    <h3 class="mb-0">Notes for {{ noteModalOrder.program_title }}</h3>
                    <closeicon class="closeicon svg-36 cursor-pointer" @click.native="modalTriggerCloseModal()"></closeicon>
                </div>
                <div slot="body">
                    <textarea v-model="noteModalOrder.judgements[0].notes"></textarea>
                </div>
                <div class="form-group-submit" slot="footer">
                    <button class="pull-left" @click="modalTriggerCloseModal()">Close</button>
                    <button class="btn btn-primary pull-right" @click.prevent="saveSelection(noteModalOrder)">Save Note</button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import modal from '../components/Modal.vue';
    import closeicon from '../components/icons/close.vue';
    import fileicon from '../components/icons/file.vue';
    import plusicon from '../components/icons/plus.vue';

    export default {
        name: "OrdersTableSearch",
        components: {modal, closeicon, fileicon, plusicon},
        props: ['year', 'return_link', 'max_selections', 'filters', 'filter_by_user', 'round', 'instructions'],
        data() {
            return {
                errors: false,
                num:20,
                page:1,
                total: 0,
                to: 0,
                sort:'',
                sort_order: 'asc',
                orders: {},
                allorders: {},
                filterActive: [],
                query_keyword: (localStorage.getItem('honors-search') != null) ? localStorage.getItem('honors-search') : '',
                query_judge_grouping: '',
                ordersSelected: 0,
                showTooManySelected: false,
                noteModalTrigger: false,
                noteModalOrder: {},
                filtergroup: '',
                savingData: false,
            }
        },
        mounted() {
            if(localStorage.getItem('honors-search-sort')) {
                this.sort = localStorage.getItem('honors-search-sort');
            }
            if(localStorage.getItem('honors-search-sort-order')) {
                this.sort_order = localStorage.getItem('honors-search-sort-order');
            }
            if(localStorage.getItem('honors-search-num')) {
                this.num = localStorage.getItem('honors-search-num');
            }
            if(localStorage.getItem('honors-search-page')) {
                this.page = localStorage.getItem('honors-search-page');
            }
            if(localStorage.getItem('honors-judge-grouping')) {
                this.query_judge_grouping = localStorage.getItem('honors-judge-grouping');
            } else {
                this.query_judge_grouping = this.filter_by_user
            }
            this.fetchOrders(this.page);
        },
        methods:{
            loadOrder(order_id){
                let app = this;
                window.location = '/submission/'+order_id+'/judging';
            },
            fetchOrders(page = 1){
                let app = this;
                axios.get('/api/orders', {
                    params: {
                        num: app.num,
                        page: page,
                        sort: app.sort,
                        sort_order: app.sort_order,
                        keyword: app.query_keyword,
                        filter_group_for_judge: app.query_judge_grouping
                        }
                    })
                    .then(res => {
                        let orderData = res.data.orders;
                        app.orders = orderData;
                        app.allorders = orderData.data;
                        app.ordersSelected = res.data.num_selections;
                        app.addVariablesToSelectionObject();
                        app.total = orderData.total;
                        app.to = orderData.to;
                        localStorage.setItem('honors-search-to', app.to);
                        localStorage.setItem('honors-search', app.query_keyword);
                        localStorage.setItem('honors-judge-grouping', app.query_judge_grouping);
                        localStorage.setItem('honors-search-num', app.num);
                        let orderIdList = _.map(app.allorders, 'order_id')
                        localStorage.setItem('honors-next-prev', orderIdList);

                        if( (app.ordersSelected == app.max_selections)) {
                            app.showTooManySelected = true;
                        }
                        app.$emit('judge_num_selections', app.ordersSelected)
                    }).catch(err => {
                    this.errors = 'Error contacting the server : ';
                    this.errors += err;
                    console.log(err)
                });
            },
            setSort(sort) {
                if (this.sort == sort) {
                    this.sort_order = (this.sort_order == 'desc')?'asc':'desc';
                } else {
                    this.sort = sort;
                    this.sort_order = 'asc';
                }
                localStorage.setItem('honors-search-sort', this.sort);
                localStorage.setItem('honors-search-sort-order', this.sort_order);
                this.fetchOrders();
            },
            clearSearch: function() {
                this.query_keyword = '';
                this.sort = '';
                this.sort_order = 'asc';
                this.num = 20;
                localStorage.removeItem('honors-search');
                localStorage.removeItem('honors-search-sort');
                localStorage.removeItem('honors-search-sort-order');
                localStorage.removeItem('honors-search-num');
                localStorage.removeItem('honors-search-page');
            },
            paginationCalculator: function(pageIndex) {
                localStorage.setItem('honors-search-page', pageIndex);
                this.fetchOrders(pageIndex);
            },
            filterData(filterVal, index) {
                // Filter data by either the click or initial user default
                let app = this;

                // If no filters are assigned don't filter by the user grouping
                if(app.filters.length == 0) { return true; }

                app.query_judge_grouping = index;
                app.fetchOrders(app.page);
            },
            saveSelection: function(order, $event) {
                let app = this;

                if(app.savingData) {
                    return;
                }
                app.savingData = true;

                let selectionVal = order.judgements[0].selection;
                if($event != undefined) {
                    if($event.target.checked) {
                        selectionVal = 1;
                    } else {
                        selectionVal = 0;
                    }
                }

                // Find if value is going up or down and determine how that changes max selected
                app.showTooManySelected = false;
                if((selectionVal > 0) && (app.ordersSelected >= app.max_selections)) {
                    app.showTooManySelected = true;
                    $event.target.checked = false;
                    return true;
                }

                let saveUrl = '/submission/' + order.id + '/judging/update/';
                axios.post(saveUrl, {
                    selection: selectionVal,
                    notes: order.judgements[0].notes
                })
                .then(res => {
                    app.noteModalTrigger = false;
                    app.addVariablesToSelectionObject();
                    app.ordersSelected = res.data.num_selections
                    if(app.ordersSelected == app.max_selections) { app.showTooManySelected = true; }
                    app.$emit('judge_num_selections', app.ordersSelected)
                    app.savingData = false;
                }).catch(error => {
                    this.errors = `Error submitting selections : ${error?.response?.data?.message}`;
                    app.savingData = false;
                });
            },
            showNoteModal: function(orderForNote) {
                let app = this;
                app.noteModalTrigger = true;
                app.noteModalOrder = orderForNote;
            },
            modalTriggerCloseModal: function() {
                let app = this;
                app.noteModalTrigger = false;
                app.noteModalOrder = {}
            },
            addVariablesToSelectionObject: function() {
                let app = this;
                app.orders.data.forEach(function(value, index) {
                    if(value.judgements.length == 0) {
                        app.orders.data[index].judgements.push({'selection': 0});
                    }
                });
            }
        },
        watch: {
            query_keyword() {
                // clear the pagination when the keyword is changing
                localStorage.removeItem('honors-search-page');
                this.fetchOrders(this.page);
                }
        }
    }
</script>
